import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ItemsDetails } from './sale-order-items-dropdown.dto';

export class SaleOrderItemsDropdownResponse extends GlobalResponseObject {
    data?: ItemsDetails[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /SaleOrderItemsDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ItemsDetails[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 